module.exports = __webpack_public_path__ + "img/ios-cellular.241c6df6.svg";